export default __webpack_public_path__ + "static/media/8-sgi-documentos-v2.c9fe31c8.png";